export enum CategoryEnum {
  WATCH = 'watch',
  STAR = 'star',
}

export type SavedProject = {
  project: number;
  category: CategoryEnum;
  collection: number;
};
